export type HeroBannerData = {
    type: "banner";
    eyebrow: string;
    headlineBeforeAccent: string;
    headlineAccent: string;
    headlineAfterAccent: string;
    body: string;
    primaryCtaText: string;
    primaryCtaHref: string;
};

export const heroBannerData: HeroBannerData = {
    type: "banner",
    eyebrow: "Garrapinada en casa",
    headlineBeforeAccent: "Snacks simples, ricos y",
    headlineAccent: "naturales",
    headlineAfterAccent: "",
    body: "Granola y garrapinada artesanal para desayunos, meriendas o antojos dulces, hechas con ingredientes simples y naturales",
    primaryCtaText: "Ver productos",
    primaryCtaHref: "/productos",
};
